<template>
  <div>
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      ลงทะเบียน
    </div>
    <!-- <v-btn @click="query.view = 'Login'" text color="primary">
      <v-icon>mdi-chevron-left</v-icon>
      กลับ
    </v-btn> -->
    <div @click="query.view = 'Login'" class="text-right pa-2 pb-0">
      <a>เข้าสู่ระบบ</a>
    </div>
    <div class="pa-5">
      <ValidationObserver ref="observer">
        <ValidationProvider
          :rules="{
            required: true,
            thai_phonenumber: true,
            digits: 10,
            regex: /^[0][3-9][0-9]{4}[0-9]{4}$/,
          }"
          name="เบอร์โทรศัพท์"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            เบอร์โทร <span class="red--text"> *</span>
          </div>

          <custom-input
            type="number"
            v-model="input.phoneNumber"
            maxlength="10"
            dense
            numberOnly
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="ชื่อ"
          v-slot="{ errors }"
        >
          <div class="grey--text">ชื่อ <span class="red--text"> *</span></div>

          <custom-input
            v-model="input.firstName"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="นามสกุล"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            นามสกุล <span class="red--text"> *</span>
          </div>

          <custom-input
            v-model="input.lastName"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="วัน-เดือน-ปี เกิด"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            วัน-เดือน-ปี เกิด <span class="red--text"> *</span>
          </div>
          <div style="width: 60%">
            <BirthdayPicker v-model="input.dob">
              <custom-input
                :value="
                  input.dob
                    ? moment(input.dob)
                        .add(543, 'year')
                        .format('DD/MM/YYYY')
                    : ''
                "
                placeholder="DD/MM/YYYY"
                dense
                readonly
                outlined
                appendOuterIcon="mdi-calendar"
                :error-messages="errors"
              ></custom-input>
            </BirthdayPicker>
          </div>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="อาชีพ"
          v-slot="{ errors }"
        >
          <div class="grey--text">อาชีพ <span class="red--text"> *</span></div>
          <v-select
            v-model="input.job"
            dense
            outlined
            :error-messages="errors"
            :items="jobOptions"
          >
          </v-select>
          <!-- <custom-input

          ></custom-input> -->
        </ValidationProvider>
        <!-- digits: 13, -->
        <ValidationProvider
          :rules="{
            required: true,
            thai_idcard: true,
          }"
          name="เลขบัตรประชาชน 13 หลัก"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            เลขบัตรประชาชน <span class="red--text"> *</span>
          </div>
          <custom-input
            v-model="input.identityNumber"
            dense
            maxlength="13"
            outlined
            numberOnly
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider name="แนบบัตรประชาชน" v-slot="{ errors }">
          <div class="grey--text">
            <span class="pr-1">แนบบัตรประชาชน</span>
            <v-tooltip bottom color="#2a72c3">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="red">
                  mdi-alert-circle-outline
                </v-icon>
              </template>
              <div class="white--text">
                หากไม่แนบบัตรประชาชน จะไม่สามารถแลกของรางวัลได้
              </div>
            </v-tooltip>
          </div>

          <UploadDocument v-model="input.identityNumberImage">
            <template v-slot="props">
              <custom-input
                :loading="props.loading"
                placeholder="แนบไฟล์"
                :value="props.filename"
                dense
                prepend-icon="mdi-attachment"
                outlined
                readonly
                :error-messages="errors"
              ></custom-input>
            </template>
          </UploadDocument>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            email: true,
          }"
          name="อีเมล"
          v-slot="{ errors }"
        >
          <div class="grey--text">อีเมล (ถ้าไม่มีให้ว่างไว้)</div>

          <custom-input
            v-model="input.email"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
            min: 6,
          }"
          vid="passwordconfirm"
          name="รหัสผ่าน"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            รหัสผ่าน <span class="red--text"> *</span>
          </div>

          <custom-input
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            v-model="input.password"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
            min: 6,
            confirmed: 'passwordconfirm',
          }"
          name="รหัสผ่าน"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            ยืนยันรหัสผ่าน <span class="red--text"> *</span>
          </div>

          <custom-input
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            v-model="input.confirm_password"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
      </ValidationObserver>
      <div>
        <v-btn
          @click="next"
          :loading="loading"
          style="font-size: 22px"
          class="text-capitalize"
          color="primary"
          dark
          block
          >ถัดไป</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import BirthdayPicker from "@/components/BirthdayPicker.vue";
import UploadDocument from "@/components/UploadSingleFile.vue";
import moment from "moment";
import axios from "axios";

export default {
  components: {
    BirthdayPicker,
    UploadDocument,
  },
  data() {
    return {
      show1: false,
      show2: false,
      loading: false,
      jobOptions: [
        "ผู้รับเหมา",
        "ช่างสี",
        "ช่างไม้",
        "ช่างฝ้า",
        "ช่างปูกระเบื้อง",
        "ช่างซ่อมบำรุง/ช่างฝีมือทั่วไป",
        "สถาปนิก / อินทีเรีย /  ดีไซเนอร์",
        "อื่นๆ",
      ],
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
    moment() {
      return moment;
    },
  },
  methods: {
    checkIDcard() {
      return new Promise((resolve) => {
        var data = {
          identity_number: this.input.identityNumber,
        };
        axios
          .get(this.serverUrl + "toacrm/check-duplicate-identitynumber", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              resolve(true);
            } else if (response.data.responsecode == 204) {
              await this.$swal.fire({
                text:
                  "เลขบัตรประชาชนนี้เคยถูกใช้ไปแล้ว กรุณาตรวจสอบใหม่อีกครั้ง",
              });
              resolve(false);
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              this.$liff.closeWindow();
            }
          });
      });
    },
    async next() {
      if (await this.$refs.observer.validate()) {
        if (this.input.identityNumberImage === "") {
          await this.$swal
            .fire({
              icon: "warning",
              text: "หากไม่แนบบัตรประชาชน จะไม่สามารถแลกของรางวัลได้",
              showCancelButton: true,
              confirmButtonText: "ข้าม",
              cancelButtonText: " กลับไปแนบ",
              customClass: "custom-swal",
              reverseButtons: true,
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                this.loading = true;
                const isIDcardAvailable = await this.checkIDcard();
                this.loading = false;
                if (isIDcardAvailable === true) {
                  this.$emit("nextstep");
                }
              }
            });
        } else {
          this.$emit("nextstep");
        }
      }
    },
  },
};
</script>

<style lang="scss">
.custom-swal .swal2-cancel {
  background-color: #fff !important;
  border: 2px solid #2a72c3 !important;
  color: #2a72c3 !important;
}
.custom-swal .swal2-confirm {
  background-color: #2a72c3 !important;
  border: 2px solid #2a72c3 !important;
}
.custom-swal-cancel .swal2-cancel {
  background-color: #fff !important;
  border: 2px solid #2a72c3 !important;
  color: #2a72c3 !important;
  width: 190px;
  padding: 12px 0;
}
.custom-swal-cancel .swal2-confirm {
  background-color: #dc000c !important;
  border: 2px solid #dc000c !important;
  width: 190px;
  padding: 12px 0;
}
</style>
